export const contact = [
  {
    label: "GitHub",
    value: "github.com/pratham4544",
    link: "https://github.com/pratham4544"
  },
  {
    label: "LinkedIn",
    value: "linkedin.com/in/prathameshshete",
    link: "https://www.linkedin.com/in/prathameshshete"
  },
  {
    label: "Email",
    value: "prathameshshete609@gmail.com",
    link: "mailto:prathameshshete609@gmail.com"
  },
  {
    label: "WhatsApp",
    value: "+91 9970939341",
    link: "https://wa.me/919970939341"
  },
  {
    label: "Location",
    value: "Pune, Maharashtra, India",
    link: null
  }
];
